import type { IconifyIcon } from "@iconify-icon/react";
import { Icon as IconifyIconComponent } from "@iconify-icon/react";
import type { ComponentPropsWithRef, SVGAttributes } from "react";
import { createElement } from "react";

import type { IconComponent } from "@/common/typings/icon-component";

interface IconNameProps extends ComponentPropsWithRef<"div"> {
  name: IconifyIcon | string;
  component?: never;
}

interface IconComponentProps extends ComponentPropsWithRef<"svg"> {
  name?: never;
  component: IconComponent;
}

type IconProps = IconNameProps | IconComponentProps;

export function Icon({ name, component, ...props }: IconProps) {
  if (name !== undefined) {
    return <IconifyIconComponent icon={name} {...(props as IconifyIcon)} />;
  }

  return createElement(component, props as SVGAttributes<SVGElement>);
}
